import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

export const sendFeedback = createAction('SEND_FEEDBACK', getPayloadCreator<Record<string, unknown>>());
export const sendFeedbackSuccess = createAction('SEND_FEEDBACK_SUCCESS', getPayloadCreator());
export const sendFeedbackFailure = createAction('SEND_FEEDBACK_FAILURE', errorPayloadCreator);
